import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { Globe2, Mail, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next") || "/";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) { toast.success("Welcome back!"); navigate(next); }
    else toast.error(res.error);
  };

  return (
    <div className="min-h-[calc(100vh-68px)] grid lg:grid-cols-2">
      <div className="hidden lg:block relative">
        <img src="https://images.unsplash.com/photo-1605538108568-7f0d77a214c1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400" alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-slate-950/40" />
        <div className="absolute bottom-12 left-12 right-12 text-white">
          <Globe2 className="w-10 h-10 mb-4" />
          <h2 className="font-heading font-black text-4xl leading-tight">Every journey begins with a single sign-in.</h2>
          <p className="text-white/80 mt-3 text-lg">Access members-only fares, manage trips and check out faster.</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-sm">
          <h1 className="font-heading font-black text-3xl text-slate-950">Sign in</h1>
          <p className="text-slate-500 mt-2">Welcome back to World Tour Hub.</p>
          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="login-form">
            <div><Label>Email</Label><div className="relative mt-1.5"><Mail className="w-4 h-4 absolute left-3 top-3 text-slate-400" /><Input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="pl-9" placeholder="you@email.com" /></div></div>
            <div><Label>Password</Label><div className="relative mt-1.5"><Lock className="w-4 h-4 absolute left-3 top-3 text-slate-400" /><Input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="pl-9" placeholder="••••••••" /></div></div>
            <Button disabled={loading} data-testid="login-submit" className="w-full rounded-full bg-brand hover:bg-brand-hover h-12 font-heading font-bold">{loading ? "Signing in…" : "Sign in"}</Button>
          </form>
          <p className="text-center text-sm text-slate-500 mt-6">New here? <Link to="/register" className="text-brand font-bold">Create an account</Link></p>
        </motion.div>
      </div>
    </div>
  );
}
